var _clipPath;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 7440 2760",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard5",
    x: 0,
    y: 0,
    width: 7440,
    height: 2760,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 7440,
    height: 2760
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2964.94,1723.33l0,-586.313l13.611,-0l314.097,586.313l229.29,0l0,-701.482l-135.061,-0l-0,586.314l-12.564,-0l-315.144,-586.314l-229.291,-0l0,701.482l135.062,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3595.23,1461.59c0,164.377 122.498,276.405 301.533,276.405c152.861,1.047 265.935,-80.618 296.298,-204.163l-130.873,0c-24.081,60.726 -81.666,99.464 -165.425,98.417c-97.37,0 -163.33,-56.537 -173.8,-143.437l470.098,-0c12.564,-184.27 -108.887,-303.627 -297.345,-303.627c-179.035,1.047 -300.486,110.981 -300.486,276.405Zm131.921,-59.678c13.611,-70.148 81.665,-112.028 169.612,-112.028c87.947,-0 149.72,41.88 162.284,112.028l-331.896,-0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4379.42,1723.33l7.329,-74.336l9.423,0c39.786,52.35 107.84,88.994 196.834,88.994c152.86,0 273.264,-113.075 273.264,-276.405c0,-163.33 -116.216,-276.405 -273.264,-276.405c-88.994,0 -156.001,36.645 -194.74,88.994l-9.423,0l0,-252.324l-124.592,-0l0,701.482l115.169,0Zm6.282,-261.747c0,-100.511 67.007,-169.612 175.894,-169.612c112.028,-0 176.941,63.866 176.941,169.612c0,105.746 -64.913,169.612 -176.941,169.612c-108.887,0 -175.894,-70.148 -175.894,-169.612Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5367.78,1199.84l-0,261.747c-0,104.699 -68.054,168.565 -166.471,168.565c-103.652,0 -144.485,-52.349 -144.485,-158.095l0,-272.217l-125.639,-0l0,287.922c0,165.424 94.229,250.23 241.855,250.23c81.665,0 148.672,-36.644 187.411,-90.041l9.423,0l7.329,75.383l115.169,0l-0,-523.494l-124.592,-0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5579.27,
    y: 1021.85,
    width: 123.545,
    height: 701.483,
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5893.37,1396.67c7.329,-73.289 56.538,-109.934 157.049,-109.934c107.84,0 151.813,36.645 151.813,115.169l0,28.269c-49.208,-9.423 -105.746,-15.705 -163.33,-15.705c-157.048,-0 -256.512,61.772 -256.512,165.424c-0,99.464 83.759,158.095 207.303,158.095c92.135,0 161.237,-35.597 205.21,-90.041l9.423,0l7.329,75.383l115.169,0l-0,-321.425c-0,-141.344 -98.417,-217.774 -276.405,-217.774c-171.706,0 -270.123,78.524 -280.593,212.539l123.544,-0Zm15.705,173.8c0,-47.114 52.35,-69.101 135.062,-69.101c61.772,-0 114.122,6.282 161.236,14.658c-16.752,73.289 -96.323,119.356 -190.552,119.356c-60.725,0 -105.746,-17.798 -105.746,-64.913Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2050.68,902.479l20.753,96.518c6.491,30.185 30.07,53.764 60.255,60.255c0,-0 96.518,20.753 96.518,20.753c-0,-0 -96.518,20.753 -96.518,20.753c-30.185,6.491 -53.764,30.07 -60.255,60.255c0,0 -20.753,96.518 -20.753,96.518c-0,-0 -20.753,-96.518 -20.753,-96.518c-6.491,-30.185 -30.07,-53.764 -60.255,-60.255c-0,0 -96.518,-20.753 -96.518,-20.753c0,-0 96.518,-20.753 96.518,-20.753c30.185,-6.491 53.764,-30.07 60.255,-60.255l20.753,-96.518Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2208.27,1526c0.015,-0.116 0.021,-0.234 0.021,-0.353l0,-281.254c0,0 309.223,0 309.223,0c0,0 0,309.223 0,309.223l-237.208,0.005c-12.527,0.041 -28.12,0.329 -41.667,4.273c-14.296,4.161 -26.322,12.335 -30.892,27.96c-4.135,14.139 -4.756,21.015 -5.471,35.802c-0.256,5.285 -0.239,218.938 -0.235,247.449l0,-0c-250.148,-1.066 -404.807,-130.07 -535.297,-293.774c-60.238,-75.569 -114.741,-158.829 -177.203,-231.376c-60.449,-70.209 -128.99,-130.579 -232.846,-142.04c-0.015,-0.001 -0.03,-0.003 -0.045,-0.004c-1.376,-0.132 -9.003,-0.871 -11.387,-1.047c-0.023,-0.002 -0.045,-0.003 -0.067,-0.005c-7.609,-0.398 -15.157,0.43 -20.39,4.751c-2.71,2.238 -4.587,5.975 -5.718,10.275c-1.492,5.671 -1.767,12.324 -1.767,16.795c-0,-0 -0,282.699 -0,282.699c-0,-0 -309.223,-0 -309.223,-0c-0,-0 -0,-309.223 -0,-309.223c-0,-0 243.168,-0 243.168,-0c0.016,-0 0.032,-0 0.048,-0.001c22.133,-0.335 45.435,-2.918 58.433,-17.576c5.465,-6.163 8.856,-14.953 10.862,-24.744c2.872,-14.016 2.962,-30.105 2.962,-42.811c-0,0 -0,-230.279 -0,-230.279c250.147,1.066 404.807,130.07 535.297,293.774c60.238,75.569 114.741,158.829 177.203,231.376c62.893,73.048 134.541,135.448 245.611,143.188c0.04,0.003 0.08,0.005 0.12,0.006c7.076,0.22 13.948,-0.789 18.825,-4.816c2.152,-1.778 3.83,-4.854 4.965,-8.499c2.266,-7.275 2.574,-16.88 2.664,-19.411l0.014,-0.363Z",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1d59e5fe.svg";
export { ForwardRef as ReactComponent };